import { useMutation } from '@apollo/client';
import UPDATE_FLASHCARD from 'graphql/mutations/flashcards/UpdateFlashcard.graphql';

export default function useUpdateFlashcardMutation() {
  return useMutation(UPDATE_FLASHCARD);
}
